import React from 'react';
import { studentWinsData } from '../data/mock';
import { useTheme } from '../ThemeContext';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';

const StudentWinsSection = () => {
  const wins = studentWinsData.wins;
  const { isDark } = useTheme();
  const { startCheckout } = useCheckout();
  const t = useT();
  const tc = isDark ? '#FFFFFF' : '#1B2A4A';

  const col1 = [wins[0], wins[3], wins[6], wins[9], wins[12]].filter(Boolean);
  const col2 = [wins[1], wins[4], wins[7], wins[10], wins[13]].filter(Boolean);
  const col3 = [wins[2], wins[5], wins[8], wins[11], wins[14]].filter(Boolean);

  return (
    <section className="relative mt-32 px-[30px] lg:px-0">
      <div className="mx-auto max-w-[1140px]">
        <h3 className="text-center text-[13px] tracking-[0.35em] font-medium uppercase transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : tc }}>{t.studentWins.label}</h3>
        <h2 className="text-center text-[32px] lg:text-[48px] font-bold mt-1 transition-colors duration-300" style={{ fontFamily: '"Space Grotesk", sans-serif', color: tc }}>{t.studentWins.title}</h2>
        <p className="text-[16px] mt-4 max-w-xl text-center mx-auto transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.6)' : 'black' }}>
          {t.studentWins.subtitle}<br />
          <span className="copy-text font-bold text-xl" style={{ color: isDark ? '#FFFFFF' : undefined }} dangerouslySetInnerHTML={{ __html: t.studentWins.subtitleBold }} />
        </p>

        <div className="flex gap-4 mt-12">
          {[col1, col2, col3].map((col, ci) => (
            <div key={ci} className="flex-1 flex flex-col gap-4">
              {col.map((src, i) => (
                <div key={i} onClick={() => startCheckout('testimonial')} className={`block overflow-hidden rounded-lg cursor-pointer ${isDark ? 'tech-border' : ''}`}>
                  <img
                    alt={`Preuve membre ${ci * 5 + i + 1}`}
                    loading="lazy"
                    className="w-full object-cover rounded-lg hover:scale-105 transition-transform duration-500"
                    src={src}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StudentWinsSection;
